export const message = {
  saveDuplicateChecker: 'Duplicate Checker successfully saved',
  publishDuplicateChecker: 'Duplicate Checker successfully published'
}